import {
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputLeftElement,
  Tooltip,
  VisuallyHidden,
} from '@chakra-ui/react';
import * as React from 'react';

import { SearchIcon } from '@/imports/ui/chakra/feather';
import { useDebouncedValue } from '@/imports/ui/hooks/useDebouncedValue';

// Note that this SearchBox is styled slightly different than others which is why its in here.
export const SearchBox: React.FC<{
  placeholder: string;
  onChange: (val: string) => void;
  value?: string;
}> = ({ placeholder, onChange, value }) => {
  const [currentValue, setCurrentValue] = React.useState(value || '');
  const debouncedValue = useDebouncedValue(currentValue, 500);
  // we've decided we dont want to allow 1 or 2 character searches. show tooltip about in these cases.
  const isValidSearch =
    debouncedValue.length === 0 || debouncedValue.length > 2;

  React.useEffect(() => {
    isValidSearch && onChange(debouncedValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedValue, isValidSearch]);

  return (
    <FormControl>
      <VisuallyHidden>
        <FormLabel>People</FormLabel>
      </VisuallyHidden>
      <Tooltip
        hasArrow
        isOpen={!isValidSearch}
        label={`Enter ${3 - debouncedValue.length} more character${
          debouncedValue.length === 1 ? 's' : ''
        }`}
        borderRadius="md"
        placement="top-start"
      >
        <InputGroup>
          <InputLeftElement pointerEvents="none">
            <SearchIcon color="primary.500" />
          </InputLeftElement>
          <Input
            variant="outline"
            borderRadius="md"
            autoComplete="cc-cvc"
            placeholder={placeholder}
            onChange={(ev) => setCurrentValue(ev.target.value)}
            value={currentValue}
          />
        </InputGroup>
      </Tooltip>
    </FormControl>
  );
};
